import { AddIcon, Alert, Button, EmptyState, ListPanel } from '@all-manager/design-system-v2';
import FullPageLayout from '../../../layout/FullPageLayout/FullPageLayout';
import QuoteGroupFormDialog from '../components/QuoteGroupFormDialog/QuoteGroupFormDialog';
import QuoteGroupList, { QuoteGroupListSkeleton } from '../components/QuoteGroupList/QuoteGroupList';
import { useQuoteGroupsPage } from './useQuoteGroupsPage';

export default function QuoteGroupsPage() {
  const hook = useQuoteGroupsPage();

  return (
    <>
      <FullPageLayout
        htmlTitle="Comparaisons de devis"
        title="Comparaison de devis"
        subtitle={hook.subtitle}
        action={hook.isAdmin && hook.groups.length > 0 ? (
          <Button variant="contained" size="small" startIcon={<AddIcon />} onClick={hook.handleOpenForm}>
            Nouvelle comparaison
          </Button>
        ) : undefined}
      >
        {hook.isError ? (
          <Alert
            severity="error"
            action={(
              <Button variant="text" size="small" color="inherit" onClick={hook.handleRetry}>
                Réessayer
              </Button>
            )}
          >
            Les comparaisons n'ont pas pu être chargées. Vérifiez votre connexion puis réessayez.
          </Alert>
        ) : (
          <ListPanel>
            {hook.isLoading ? (
              <QuoteGroupListSkeleton />
            ) : hook.groups.length === 0 ? (
              <EmptyState
                title="Aucune comparaison de devis"
                subtitle={hook.isAdmin
                  ? 'Créez une comparaison pour un projet (toiture, ravalement…) puis ajoutez les devis reçus.'
                  : 'Les comparaisons de devis apparaîtront ici dès qu\'un administrateur en aura créé une.'}
                action={hook.isAdmin ? (
                  <Button variant="contained" size="small" startIcon={<AddIcon />} onClick={hook.handleOpenForm}>
                    Créer une comparaison
                  </Button>
                ) : undefined}
              />
            ) : (
              <QuoteGroupList
                groups={hook.groups}
                isAdmin={hook.isAdmin}
                getHref={hook.getHref}
                onOpen={hook.handleOpenGroup}
              />
            )}
          </ListPanel>
        )}
      </FullPageLayout>

      {hook.isFormOpen ? (
        <QuoteGroupFormDialog onClose={hook.handleCloseForm} afterSuccess={hook.handleGroupCreated} />
      ) : null}
    </>
  );
}
